import * as React from "react";
const SvgFiRrBoneBreak = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bone-break_svg__a)">
      <path
        fill="#062147"
        d="M22.819 15.831Q23 16.402 23 17c0 2.206-1.794 4-4 4s-4-1.794-4-4l.001-.108L12 16.03l-3.001.862L9 17c0 2.206-1.794 4-4 4s-4-1.794-4-4q0-.598.181-1.169A3.97 3.97 0 0 1 0 13c0-2.206 1.794-4 4-4a3.99 3.99 0 0 1 3.471 2.03l2.24-.677a1 1 0 0 1 .58 1.914l-3.106.939a1 1 0 0 1-1.257-.706A1.995 1.995 0 0 0 4.002 11c-1.103 0-2 .897-2 2 0 .684.35 1.314.935 1.685a1 1 0 0 1 .335 1.338 1.97 1.97 0 0 0-.27.977c0 1.103.897 2 2 2s2-.897 2-2a2 2 0 0 0-.084-.548 1 1 0 0 1 .685-1.239l4.124-1.185a1 1 0 0 1 .552 0l4.124 1.185a1 1 0 0 1 .685 1.239 2 2 0 0 0-.084.548c0 1.103.897 2 2 2s2-.897 2-2q0-.501-.27-.977a1 1 0 0 1 .335-1.338A1.99 1.99 0 0 0 22.004 13c0-1.103-.897-2-2-2-.92 0-1.715.628-1.935 1.527a.997.997 0 0 1-1.248.724l-3.094-.888a1 1 0 0 1-.685-1.237.997.997 0 0 1 1.237-.685l2.222.638A3.98 3.98 0 0 1 20.003 9c2.206 0 4 1.794 4 4 0 1.079-.43 2.089-1.181 2.831zM12 7a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1m3.779.377a1.002 1.002 0 0 0 1.369-.357l1.474-2.514a1 1 0 0 0-1.726-1.012l-1.474 2.514a1 1 0 0 0 .357 1.369m-8.87-.274a1 1 0 0 0 1.363.377 1 1 0 0 0 .377-1.363l-1.478-2.61a1 1 0 0 0-1.74.986z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bone-break_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoneBreak;
